import useGetDatasetLastUpdatedAt from '../../../../hooks/dashboards/useGetDatasetLastUpdatedAt';
import { useContext, useEffect, useState } from 'react';
import { DateTime } from 'luxon';
import getDatasetsLastUpdatedAt from '../../../../api/getDatasetsLastUpdatedAt';
import GqlClientContext from '../../../../contexts/GqlClientContext';

const useBaseViewsLastUpdatedAtLookup = (
  datasets: FleetOps.DatasetDefinition[],
) => {
  const getDatasetLastUpdatedAt = useGetDatasetLastUpdatedAt();
  const [baseViewsLastUpdatedAtLookup, setBaseViewsLastUpdatedAtLookup] =
    useState<{ [dataset: string]: number | undefined }>({});
  const { client } = useContext(GqlClientContext);

  useEffect(() => {
    if (process.env.NODE_ENV === 'test') {
      return;
    }

    getDatasetsLastUpdatedAt(client).then((result) => {
      const newLookup = {} as { [dataset: string]: number | undefined };
      result.forEach(({ name, latestRecordTimeStamp }) => {
        newLookup[name] = DateTime.fromISO(latestRecordTimeStamp).toMillis();
      });
      setBaseViewsLastUpdatedAtLookup(newLookup);
    });
  }, [client, datasets, getDatasetLastUpdatedAt]);

  return baseViewsLastUpdatedAtLookup;
};

export default useBaseViewsLastUpdatedAtLookup;
